
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38.03 42.87"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_20","data-name":"Layer 20"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M36.47 36.07H1.56c-.45 0-.81.36-.81.81v4.48c0 .42.34.76.76.76h3.42c.42 0 .76-.34.76-.76v-1.64h26.65v1.64c0 .42.34.76.76.76h3.42c.42 0 .76-.34.76-.76v-4.48c0-.45-.36-.81-.81-.81z"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"1.99","y":"18.38","width":"15.45","height":"15.45","rx":"1","ry":"1"}}),_c('rect',{attrs:{"x":"6.89","y":"19.94","width":"5.68","height":"2.35","rx":".45","ry":".45"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"20.65","y":"18.38","width":"15.45","height":"15.45","rx":"1","ry":"1"}}),_c('rect',{attrs:{"x":"25.54","y":"19.94","width":"5.68","height":"2.35","rx":".45","ry":".45"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"11.3","y":".75","width":"15.45","height":"15.45","rx":"1","ry":"1"}}),_c('rect',{attrs:{"x":"16.2","y":"2.1","width":"5.68","height":"2.35","rx":".45","ry":".45"}})])])
          )
        }
      }
    